import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InboxIcon from '@mui/icons-material/Inbox';
import { BasketView } from './BasketView';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'utils/translation';
import { Theme } from '../../../theme';
import { BasketTabs } from './BasketTabs';
import { ModalClose } from '../../../components';
import { useShouldModalBeFullscreen } from '../../../utils/media-query';

const useStyles = makeStyles((theme: Theme) => ({
  close: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    display: 'flex',
    fontSize: 24,
  },
  icon: {
    display: 'inline-flex',
    alignSelf: 'center',
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
}

export const BasketViewModal: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const fullScreen = useShouldModalBeFullscreen();

  return (
    <Dialog
      aria-labelledby="basket-modal"
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={fullScreen}
      maxWidth="sm"
    >
      <ModalClose onClose={onClose} />
      <DialogTitle>
        <Typography variant="h3" className={classes.title}>
          <InboxIcon className={classes.icon} />
          {t('Basket')}
        </Typography>
        <IconButton className={classes.close} onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <BasketTabs />
      <DialogContent>
        <BasketView />
      </DialogContent>
    </Dialog>
  );
};
